/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Общий вид для корзины.
   */
  app.CartCommonView = app.RestCommonView.extend({
    el: '[data-jsview="cart"] .reducer',
    events: {
      'click .catalog-sort_cart .catalog-show .link_dark': 'changePageSize',
      'click .catalog-sort': 'showSort',
      'click .catalog-sort .js-sort': 'changeSort',
      'click .more-sort': 'toggleOptionsPopup',
      'click .filter_but': 'toggleFiltersList',
      'click .js-opener-dialog-popup': 'openDialogPopup',
      'click': 'hideOptionsPopup',
      'click .upsale-items .recommendation-name': 'triggerUpsaleItemClick',
    },
    sortTemplateId: '#main-sort-filter',
    shownSortThreshold: 3,
    jsView: 'cart',
    additionalOptions: [
      'sortTemplateId',
      'mainWindow',
      'router',
      'bodyView',
      'hasGiftsForActions',
      'currency',
      'fader'
    ],
    reachedTheEnd: false,
    removeChecked: false,

    /**
     * Устанавливает флаг показывающий, доскроллили ли мы до конца.
     * @param toggle
     */
    setReachTheEnd: function (toggle) {
      this.reachedTheEnd = toggle;
    },

    /** @inheritDoc */
    run: function () {
      this.childViews = {};
      this.settlement.expand = 'expand=has_active_jp_purchase,jp_request_min_sum';
      this.togglePreventScroll(false);
      this.createTemplates();
      this.startView();
      this.initEventListeners();
    },

    /**
     * Собирает необходимые шаблоны.
     */
    createTemplates: function () {
      this.sortFilterTemplate = app.helpers.TemplateHelper.getTemplate(this.sortTemplateId);
      this.cartTitleTemplate = app.helpers.TemplateHelper.getTemplate('#cart-h1-template');
      this.limitSwitchTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-limit-switch');
    },

    /**
     * Инициализирует слушатели событий.
     */
    initEventListeners: function () {
      this.listenTo(this.model, 'removeCheckedFromCart', this.updateOnRemove);
      this.listenTo(this.model, 'update', this.updateCart);
      this.listenTo(this.model, 'sync', this.render);
      this.listenTo(this.model, 'sync', function () {
        if (this.model.fetchCounter === 1) {
          this.cartIsLoyal = this.model.cartInfo.is_loyal;
        }
      });
      this.listenTo(this.model, 'updateQty', function () {
        if (this.model.cartInfo.is_loyal !== this.cartIsLoyal) {
          this.cartIsLoyal = this.model.cartInfo.is_loyal;
          this.model.fetch();
        }
      });
      this.listenTo(this.model, 'empty-cart', this.render);
      this.listenTo(this.model, 'clickFilter', function () {
        this.toggleFiltersList();
        this.changeHeader();
      });
      if (!app.isMobile) {
        this.childViews.paginationView = new app.CartPaginationView({
          model: this.model,
          router: this.router
        });
        this.childViews.paginationView.listenTo(this, 'hide-pagination', this.childViews.paginationView.hide);
        this.childViews.paginationView.listenTo(this, 'show-pagination', this.childViews.paginationView.show);
        // слушаем событие изменения GET параметра sort
        this.listenTo(this.router, 'change-sort change-pagesize change-mode', this.choice);
        this.listenTo(this.router, 'change-page', function () {
          this.scrollToTop();
          this.choice();
        });
        this.listenTo(this.model, 'reset-cart', this.scrollToTop);
      } else {
        // слушаем событие изменения GET параметра sort
        this.listenTo(this.router, 'change-sort', this.choice);

        // слушаем событие при удалении товара с корзины
        this.listenTo(Backbone, 'DeleteItemFromCart', this.checkFiltersAvailability);

        this.listenTo(this.mainWindow, 'window.scroll', this.triggerUpsaleBlockShow);
      }

      // организация бесконечной прокрутки
      this.listenTo(this.mainWindow, 'window.scroll', this.onPageScroll);
      this.listenTo(this, 'InfiniteScroll', this.fetchScroll);
      this.listenTo(this.model, 'update-on-discount-complete', this._fetchItems);
      this.listenTo(this.settlement, 'sync', this.toggleFiltersOpener);
      this.listenTo(Backbone, 'cart-aside:need-update-margin', this.updateAsideMargin);
    },

    /**
     * Смена заголовка при переключении фильтра.
     */
    changeHeader: function () {
      var template = app.helpers.TemplateHelper.getTemplate('#cart-title-template');
      this.$('.title-cart-table').html(template({ type: this.model.queryParams.group || 'all' }));
    },

    /**
     * Заполнение коллекции товаров при прокрутке до конца списка.
     */
    fetchScroll: function () {
      if (this.model.hasNextPage()) {
        this.renderInfinitePreloader();
        this.model.fullCollection.reset();
        this.cartIsFetching = true;
        this.model.getNextPage({
          remove: false,
          success: function () {
            this.cartIsFetching = false;
          }.bind(this),
        });
        this.model.isScroll = true;
      }
    },

    /**
     * Обновляет чекбоксы при удалении товаров из коллекции.
     */
    updateOnRemove: function () {
      this.removeChecked = true;  //временное решение
      this.childViews.cartItemsView.updateGridButtons();
      $('#c12345').prop('checked', false);
    },

    /**
     * @inheritDoc
     */
    render: function () {
      var $aside = this.$('.extra'),
        $holder = this.$('.holder'),
        $main = this.$('.main'),
        $dialogOpener,
        activeSort = this.model.sort,
        sortTemplateParams,
        sortParentSelector = '.catalog-sort_cart>.catalog-sort';
      if (app.isMobile) {
        this.toggleFiltersOpener();
        $aside = this.$('.cart-info');
        $dialogOpener = this.$('.js-opener-dialog-popup');
      } else {
        this.extractShownSortTypes(activeSort);
      }
      var templatesAvailable = _.includes(this.sortFilterTemplate.source, 'more-sort');
      sortTemplateParams = {
        sort: this.model.sort,
        sortTypes: templatesAvailable && this.shownSortThreshold && this.showSortTypes ? this.showSortTypes : this.model.sortTypes,
        moreSortTypes: this.moreSortTypes,
        hasDiscountItems: this.model.state.hasDiscountItems,
        pageSize: this.model.state.pageSize,
        mode: this.router.mode,
      };
      if (this.model.totalCount || !_.isEmpty(this.model.giftsForActions)) {
        if (app.isMobile) {
          $dialogOpener.removeClass('not_display');
          this.startDialogPopup();
        }
        $aside.removeClass('not_display');
        this.$('.catalog-holder').show();
        this.$('.empty-cart').hide();
        if ($aside.length && $holder.length && $main.length && !app.isMobile) {
          var topMargin = app.isTerminal ? 180 : 25;
          new als.VerticalFixer($holder, $aside, $main, $aside, topMargin);
        }
      } else {
        if(app.isMobile) {
          $dialogOpener.addClass('not_display');
        }
        $aside.addClass('not_display');
        this.$('.catalog-holder').hide();
        this.$('.empty-cart').show();
      }
      if (this.sortTemplateId === '#cart-sort-filter') {
        sortParentSelector = '.catalog-row';
      }
      // Отрисовка сортировок
      if (!app.isMobile) {
        this.$(sortParentSelector).html(this.sortFilterTemplate(sortTemplateParams));
        if (this.sortTemplateId !== '#cart-sort-filter') {
          this.$('.catalog-show').html(this.limitSwitchTemplate({
            pageSize: this.model.state.pageSize,
            mode: this.router.mode,
          }));
        }
      } else {
        this.checkFiltersAvailability();
        this.changeHeader();
        this.showCatalogRow();
        this.$('.catalog-sort').html(this.sortFilterTemplate(sortTemplateParams));
      }
      this.togglePreventScroll(false);
      app.preloader.remove();
      if (this.childViews.loader) {
        this.childViews.loader.remove();
      }
      if (this.infinitePreloader) {
        this.infinitePreloader.remove();
      }
      return this;
    },

    /**
     * Изменяет тип сортировки в коллекции.
     * @param e
     */
    changeSort: function (e) {
      var params = app.helpers.UrlHelper.getUrlParameters();
      var sort = $(e.target).data('sort');
      params.sort = params.sort ? params.sort : '';
      this.saveSortTypeToCookie(sort);
      if( params.sort !== sort ) {
        var url = app.helpers.UrlHelper.to('/', ['per-page', 'currency', 'mode', 'viewtype'], {'sort': sort}, false);
        this.router.navigate(url, {trigger: true});
      }
    },

    /**
     * Показывает блок сортировок
     */
    showCatalogRow: function () {
      this.$('.catalog-row').removeClass('not_display');
    },

    /**
     * Обновляет чекбоксы при изменении параметров коллекции.
     */
    choice: function () {
      this.childViews.cartItemsView.updateGridButtons();
      $('#c12345').prop('checked', false);
    },

    /**
     * Изменяет количество товаров на странице.
     * @param e
     */
    changePageSize: function (e) {
      var pageSize = $(e.target).data('pagesize'),
        mode = $(e.target).data('mode'),
        newCurrentPage = this.model.getCurrentPageByPageSize(pageSize),
        fragment = this.router.getPathFragment();
      if (newCurrentPage !== this.model.state.currentPage) {
        fragment = '/p' + newCurrentPage;
        if (newCurrentPage === 1) {
          fragment = '/';
        }
      }
      if (mode === 'infinite') {
        fragment = '/';
      }
      var params = {
        'per-page': pageSize
      };
      if (mode !== this.router.mode) {
        if (mode === 'infinite') {
          this.trigger('hide-pagination');
        } else {
          this.trigger('show-pagination');
        }
        params.mode = mode;
      }
      this.router.navigate(fragment, {
        trigger: true
      }, params);
    },

    /**
     * Инициализация необходимых view
     */
    startView: function () {
      var options = {
        user: this.user,
        cart: this.model,
        settlement: this.settlement,
        el: '.js-cart-bill-block',
        mainWindow: this.mainWindow,
      };
      if (app.isMobile) {
        options.el = '.cart-info';
        options.bodyView = this.bodyView;
        if (app.features.is_upsale_block_in_mobile) {
          this.initUpsaleCarousel();
        }
      } else {
        this.childViews.cartAddByArticulView = new app.CartAddByArticul({cart: this.model});
      }
      this.childViews.cartBillView = new app.CartBillView(options);
      this.childViews.giftsView = new app.GiftsView({
        cart: this.model
      });
      if (this.hasGiftsForActions) {
        this.childViews.giftsForActions = new app.GiftsForActionsView({
          cart: this.model
        });
      }
      this.childViews.cartDiscountsView = new app.CartDiscountsView({model: this.model.discounts});
      this.childViews.cartItemsView = new app.CartItemsView({
        model: this.model,
        settlement: this.settlement,
        mainWindow: this.mainWindow,
        bodyView: this.bodyView,
        user: this.user,
        currency: this.currency,
        isDynamicDeliverySegment: app.features && app.features.is_dynamic_item_delivery_view_cart,
      });
      var tabsOptions = {
        model: this.model,
        settlement: this.settlement,
      };
      this.childViews.cartTabsView = new app.CartTabsView(tabsOptions);
      if (this.hasGiftsForActions && this.user.get('id')) {
        this.childViews.cartGiftMessageView = new app.CartGiftMessageView({
          el: this.$('.has-gift-message'),
          user: this.user,
          collection: new app.GiftSets(),
        });
      }
    },

    /**
     * Инициализация карусели с товарами допродажи.
     */
    initUpsaleCarousel: function () {
      this.childViews.upsaleCarouselView = new app.PersonalRecommendationsView({
        el: '.upsale-items',
        model: new app.Upsale(),
        title: 'Выгодное предложение',
        settlement: this.settlement,
        user: this.user,
        cart: this.model,
        mainWindow: this.mainWindow,
      });
    },

    /**
     * Отправка события показа блока выгодное предложение для око
     */
    triggerUpsaleBlockShow: function () {
      var $body = $('body');
      var $carousel = $('.upsale-items');
      if (window.pageYOffset + $body.height() >= $carousel.offset().top) {
        Backbone.trigger('upsale-item', 'show');
        this.stopListening(this.mainWindow, 'window.scroll', this.triggerUpsaleBlockShow);
      }
    },

    /**
     * Отправка события клика на товаре для око
     */
    triggerUpsaleItemClick: function (e) {
      if (app.isMobile) {
        var sid = $(e.target).parents().data('sid');
        Backbone.trigger('upsale-item', 'click', sid);
      }
    },

    /**
     * Вызывает событие необходимости загрузки товаров при прокрутке до конца списка.
     */
    onPageScroll: function () {
      var $window = $(window);
      var $anchor = $('.infinityScrollData');
      var isListVisible = $anchor.outerHeight() > 0;
      var listIsFullyScrolled = $window.scrollTop() + $window.height() >= $anchor.offset().top + $anchor.height();
      var infiniteScrollIsActive = app.isMobile || this.router.mode === 'infinite';
      if (isListVisible
        && !this.cartIsFetching
        && !this.preventScroll
        && infiniteScrollIsActive
        && listIsFullyScrolled) {
        // нужно для того, чтобы при первоначальной загрузке с положением в самом низу страницы можно было прокрутить
        if (this.model.fetchCounter > 1) {
          this.togglePreventScroll(true);
        }
        this.trigger('InfiniteScroll');
      }
    },

    /**
     * Обновляем заголовок и корзину
     */
    updateCart: function () {
      var itemsCount = this.model.cartInfo.items_count,
        viewItemsCount = this.viewItemsCount;
      if (itemsCount !== viewItemsCount) {
        this.viewItemsCount = itemsCount;
      }
      this.updateHeader();
      if (itemsCount < viewItemsCount && !this.removeChecked) {
          this.updateCartItems();
      }
      if (this.childViews.cartGiftMessageView) {
        this.childViews.cartGiftMessageView.fetchAvailableGifts();
      }
      this.removeChecked = false;
    },

    /**
     * Обновление заголовка h1 в корзине при изменении состава корзины.
     */
    updateHeader: function () {
      this.$('.cart-title').html(this.cartTitleTemplate({
        itemsCount: this.model.totalCount,
        unitFormat: app.helpers.DeclinationHelper.format,
      }));
    },

    /**
     * При удалении товаров перерисовываем товары
     */
    updateCartItems: function () {
      var isFirstPage = this.model.state.currentPage === this.model.state.firstPage;
      if (this.router.mode === 'infinite') {
        if (!this.model.hasNextPage()) {
          this.lastReq = this.model.fetch({ withoutUpdateCollectionModels: true });
          return;
        }
        if (!isFirstPage) {
          this.model.state.currentPage = this.model.state.firstPage;
          this.scrollToTop();
        }
      }

      // Если уже был сделан запрос, отменяем его, чтобы не отрисовались устаревшие данные
      if (this.lastReq && typeof this.lastReq.abort === 'function') {
        this.lastReq.abort();
      }
      clearTimeout(this.fetchTimeout);

      // Ждем, когда пройдет 500мс с последнего удаления товара
      this.fetchTimeout = setTimeout(this._fetchItems.bind(this), 500);
    },

    /**
     * Обновление корзины.
     */
    _fetchItems: function () {
      this.lastReq = this.model.fetch();
    },

    /**
     * Выпадающее меню сортировки на мобильной версии
     */
    showSort: function () {
      this.$('.catalog-sort').toggleClass('active');
      if (app.isMobile) {
        var isFiltersShown = this.$('.filter_but').hasClass('active');
        if (isFiltersShown) {
          this.toggleFilters(false);
        }
      }
    },

    /**
     * Показ / скрытие списка фильтров
     */
    toggleFiltersList: function () {
      if (!this.model.getGroups()) {
        return;
      }
      var isSortShown = this.$('.catalog-sort').hasClass('active');
      if (isSortShown) {
        this.showSort();
      }
      this.$('.filter_but').toggleClass('active');
      this.$('.js-filters-list').toggleClass('not_display');
    },

    /**
     * Показ/скрытие инициатора фильтров.
     */
    toggleFiltersOpener: function () {
      var $el = this.$('.filter_but');
      if ($el.length) {
        $el.toggleClass('not_display', !this.settlement.isRemoteStoreEnabled());
      }
    },
    /**
     * Проверка на доступность кнопки фильтров
     */
    checkFiltersAvailability: function () {
      var groups = this.model.getGroups();
      this.$('.filters-list').toggleClass('not_display', !groups);
    },

    /**
     *  Попап для мобильной версии с удалением всего из корзины/добавление всего в избранное
     */
    startDialogPopup: function () {
      this.childViews.mobileCartDialogPopup = new app.MobileCartDialogPopup({
        model: this.model,
        el: '.js-dialog-cart-popup-all',
        dialogPopUp: new als.Popup(this.$('.js-dialog-cart-popup-all'), this.$('.js-opener-dialog-popup'), false, false)
      });
    },

    /**
     * Добавление класса с отступом к сайдбару при наличии табов и отсутствии сообщения о подарке
     */
    updateAsideMargin: function () {
      var hasTabs = Boolean(this.childViews.cartTabsView && this.childViews.cartTabsView.$el.children().length);
      var hasGiftMessage = Boolean(this.childViews.cartGiftMessageView && this.childViews.cartGiftMessageView.$el.children().length);
      var isClassNeeded = hasTabs && !hasGiftMessage;
      this.childViews.cartBillView.$el.toggleClass('additional-margin', isClassNeeded);
    },
  });
})(jQuery);

}.call(window));